module.exports = __webpack_public_path__ + "0a22d66f.svg";